<div class="generate-link-container">
  <div class="input-container">
    <app-select-input [fieldInfo]="trackingDomains" (emitValue)="getValue($event)" [defaultValue]="defaultTrackingDomainValue"> </app-select-input>
    <div class="information-link mb-4">
      <a href="#">{{ 'view_translations.how_choose_tracking_domain' | translate }}</a>
    </div>
    <ng-container *ngIf="this.landings && this.landings.length > 0">
      <app-input-select
        [label]="'choosing_landing_creation' | t"
        [options]="this.landings"
        [required]="false"
        [submitted]="true"
        [multiple]="false"
        [large]="true"
        [search]="false"
        (emitChange)="getLanding($event)">
      </app-input-select>
    </ng-container>
    <div class="additional-link-paramters-container">
      <app-additional-link-parameters (emitSubs)="getSubs($event)"></app-additional-link-parameters>
    </div>

    <div class="generated-url-container">
      <app-generated-url [generatedURL]="generatedURL"></app-generated-url>
    </div>
  </div>
  <div class="modal-footer">
    <div class="grey-btn" (click)="activeModal.close()">{{ 'view_translations.close' | translate }}</div>
  </div>
</div>
